// icon:bx-home-heart | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Asso.png";

function IconBxHomeHeart(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Asso"} />
	)
}

export default IconBxHomeHeart;
